import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videoData';
import { siteInfo } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl text-background-50">爱液视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-3">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors text-background-300 hover:text-background-50">
                <i className="ri-weibo-line"></i>
              </a>
              <a href={siteInfo.socialLinks.bilibili} target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors text-background-300 hover:text-background-50">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-500 transition-colors text-background-300 hover:text-background-50">
                <i className="ri-wechat-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-50 transition-colors">网站首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><Link to="/category/dongzuo" className="text-sm text-background-400 hover:text-background-50 transition-colors">热门推荐</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-50 transition-colors">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-background-50 transition-colors">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-background-500 mt-0.5"></i>
                <span className="text-sm text-background-400">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-5 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 爱液视频 版权所有 | 精选高清视频资源聚合平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}